import React, { useState } from "react";
import { OrderDetailsData } from "../../contexts";

import RightBar from "../../layouts/Dashboard/components/rightbar";
import AllOrderDetailsRightBar from "../all-orders/components/rightsidebar/rightsidebar_details";
import { OrdersTable } from "../all-orders/components";
import { ALL_ORDER_TYPE } from "../../utils/constants";
import { GetPartners } from "../../hooks/fetch-hooks/partners/get-partners";

/**
 * Partner Orders — the ordinary orders table scoped to partner-placed orders.
 *
 * Reuses OrdersTable wholesale (status filter, search, pagination, row actions all come
 * for free); the only addition is a partner selector, threaded down through
 * OrderDetailsData so the table's existing query builder picks it up.
 *
 * No backend work was needed: userOrders already exposes partnerId and status as
 * filterable query params on GET /userOrder/admin.
 */
function PartnerOrders() {
    const [data, setData] = useState();
    const [rightBarOpen, setRightBarOpen] = useState({
        name: "partner-orders",
        open: false,
    });
    const [OrderType, setOrderType] = useState(ALL_ORDER_TYPE);
    // '' = every partner. Deliberately not defaulted to the first partner — landing on an
    // unannounced subset of orders is worse than showing everything.
    const [partnerId, setPartnerId] = useState('');

    const { data: partnersResponse, isLoading: partnersLoading } = GetPartners();
    const partners = partnersResponse?.data?.data?.rows || [];

    const changeRightBarOpen = () => {
        if (!rightBarOpen.open) {
            setRightBarOpen({ ...rightBarOpen, open: true });
        }
    };
    const changeRightBarClose = () => {
        setRightBarOpen({ ...rightBarOpen, open: false });
    };

    return (
        <div className="p-7 h-full overflow-y-scroll bg-gray-50">
            <RightBar
                rightBarOpenAction={changeRightBarOpen}
                rightBarCloseAction={changeRightBarClose}
                value={rightBarOpen.open}
                data={data}>
                <AllOrderDetailsRightBar {...data} />
            </RightBar>

            <div className="flex flex-row items-end gap-3 flex-wrap">
                <div className="flex flex-col">
                    <label className="text-sm font-semibold text-cod-gray-700 mb-1">Partner</label>
                    <select
                        className="rounded-lg h-10 min-w-[220px] border-white-200"
                        value={partnerId}
                        disabled={partnersLoading}
                        onChange={(e) => setPartnerId(e.target.value)}
                    >
                        <option value="">
                            {partnersLoading ? 'Loading partners…' : 'All partners'}
                        </option>
                        {partners.map((partner) => (
                            <option key={partner.id} value={partner.id}>{partner.name}</option>
                        ))}
                    </select>
                </div>
                {partnerId && (
                    <button
                        className="rounded-lg border border-white-200 bg-white-50 px-3 py-2 text-xs font-semibold text-cod-gray-600 hover:bg-white-100"
                        onClick={() => setPartnerId('')}
                    >
                        Clear partner
                    </button>
                )}
            </div>

            <OrderDetailsData.Provider value={{ data, setData, OrderType, setOrderType, isReorder: false, partnerId }}>
                <OrdersTable changeRightBarOpen={changeRightBarOpen} />
            </OrderDetailsData.Provider>
        </div>
    );
}

export { PartnerOrders };
